import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Carousel from '../components/Carousel';
import FutureMoviesList from '../components/FutureMoviesList';
import TrailerSpotlight from '../components/TrailerSpotlight';
import { useCurrentMovies, useUpcomingMovies, useFutureMovies } from '../hooks/useMovies';

import { Link } from 'react-router-dom';

const Home = () => {
  const {
    movies: currentMovies,
    loading: currentLoading,
    error: currentError,
    refresh: refreshCurrent
  } = useCurrentMovies();

  const {
    movies: upcomingMovies,
    loading: upcomingLoading,
    error: upcomingError,
    refresh: refreshUpcoming
  } = useUpcomingMovies();

  const {
    movies: futureMovies,
    loading: futureLoading,
    error: futureError,
    hasMore,
    loadMore
  } = useFutureMovies(10);

  return (
    <main>
      <Helmet>
        <title>Next in Cinema - Upcoming Movies and Releases</title>
        <meta name="description" content="Discover upcoming movie releases, trailers, and information about the latest films coming to theaters." />
        <meta property="og:title" content="Next in Cinema - Upcoming Movies and Releases" />
        <meta property="og:description" content="Discover upcoming movie releases, trailers, and information about the latest films coming to theaters." />
        <meta property="og:url" content="https://www.nextincinema.com" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://www.nextincinema.com" />
      </Helmet>
      
      <Hero />
      
      {/* User Greeting */}
      <div className="relative z-20 bg-background-light/80 backdrop-blur-sm border-b border-secondary/10">
        <div className="container-custom">
        </div>
      </div>
      
      <div className="relative z-20 mt-8 md:-mt-32 py-8">
        <Carousel
          id="current-movies"
          title="Now Showing"
          tooltipText="Movies released in the last 30 days"
          movies={currentMovies}
          loading={currentLoading}
          error={currentError}
          refresh={refreshCurrent}
        />
        <Carousel
          id="upcoming-movies"
          title="Coming Soon"
          tooltipText="Movies coming in the next 90 days"
          movies={upcomingMovies}
          loading={upcomingLoading}
          error={upcomingError}
          refresh={refreshUpcoming}
        />

        <TrailerSpotlight />
      <div className="text-center mt-8 space-y-4">
        <p className="text-secondary text-lg">
          A movie is missing? <Link to="/suggest-movie" className="text-blue-500 hover:underline">Tell us here</Link>
        </p>
        <p className="text-secondary text-lg">
          Looking for older movies? <Link to="/archive" className="text-blue-500 hover:underline">Browse our archive</Link>
        </p>
      </div>
        <FutureMoviesList
          movies={futureMovies}
          loading={futureLoading}
          error={futureError}
          hasMore={hasMore}
          loadMore={loadMore}
        />
      </div>
      <footer className="container-custom py-8 border-t border-secondary/10">
        <p className="text-secondary text-sm text-center">
          Posters and promotional materials are used under fair use for promotional purposes. All images are © their respective copyright holders, including Disney, Warner Bros., and Universal Pictures.
        </p>
      </footer>
    </main>
  );
};

export default Home;